/* ContentListPage — index of all CMS-managed pages. */
import { Link } from "react-router-dom";
import { ALL_SCHEMAS } from "./contentSchemas";

export default function ContentListPage() {
  return (
    <div data-testid="admin-content-list" className="pb-20">
      <div className="mb-9">
        <div className="text-[0.62rem] font-bold tracking-[0.3em] uppercase text-[#F4D64E]">Pages</div>
        <h1 className="mt-3 font-display text-3xl font-black tracking-[-0.025em]">Content</h1>
        <p className="mt-3 text-sm text-neutral-400 max-w-xl leading-relaxed">
          Edit headlines, body copy, calls-to-action, images and links for
          every public page. Visual design is locked — only the content
          surfaces below are editable. Empty fields fall back to the original
          design defaults so the page never breaks.
        </p>
      </div>

      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {ALL_SCHEMAS.map((s) => (
          <li
            key={s.key}
            className="bg-[#0F141A] border border-white/[0.06] rounded-xl p-6 hover:border-[#F4D64E]/30 transition-colors"
          >
            <div className="text-[0.6rem] font-bold tracking-[0.22em] uppercase text-neutral-500">
              {s.route}
            </div>
            <h3 className="mt-2 font-display text-xl font-black tracking-[-0.02em]">{s.label}</h3>
            <Link
              to={`/admin/content/${s.key}`}
              data-testid={`content-edit-${s.key}`}
              className="mt-5 inline-flex items-center gap-2 px-4 py-2 rounded-md text-[0.7rem] font-bold tracking-[0.18em] uppercase text-neutral-950 bg-[#F4D64E] hover:bg-white transition-colors"
            >
              Edit content →
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
